<div class="site">
  <router-outlet></router-outlet>
</div>
<app-loader [isButton]="false" [background]="'rgba(0,0,0,.9)'" [fullPage]="true" [text]="'Wait less than one minute'">
</app-loader>
